import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import RequestQuoteModal from '../components/RequestQuoteModal';

const products = [
  {
    id: 1,
    category: 'medical-gas',
    name: 'Theatre Suction Trolley',
    description: 'Mobile unit with suction pump and canisters for surgical fluid removal.',
    features: [
      "Vacuum Pump: Generates the negative pressure required for suction. It may be electrically powered or manually operated.",
"Collection Canisters: Often multiple jars (including a safety jar) to collect aspirated fluids while preventing contamination or overflow.",
"Bacterial/Viral Filters: Prevent pathogens from entering the vacuum system, protecting both patients and healthcare workers.",
"Tubing and Suction Catheters: Flexible and disposable tubing systems used to draw fluids from the patient to the collection jars.",
"Trolley Frame: A wheeled base that provides mobility, allowing the unit to be easily transported between operating rooms and wards.",
    ],
    image: '/images/products/theater-suction-trolly.jpg',
    details: "This Theatre Suction Trolley is designed for efficient and reliable surgical fluid removal in operating theatres. It features a powerful suction pump, multiple collection canisters, and a robust, easy-to-clean stainless steel frame. Its smooth-rolling casters ensure easy maneuverability within the theatre environment. Ideal for busy surgical settings requiring quick and hygienic operation.A theater suction trolley is a mobile medical device used in operating rooms to provide effective suction during surgical procedures. It helps maintain a clear surgical field by removing blood, mucus, and other bodily fluids. Typically equipped with a suction pump, collection jars, tubing, and pressure controls, it ensures efficient fluid management. The trolley's mobility allows it to be easily positioned as needed during operations. Designed for hygiene and safety, many units feature antibacterial filters and autoclavable components. Quiet operation, adjustable suction power, and ease of cleaning make it an essential tool for surgical teams in hospitals and clinics.",
    specifications: ["HB-2511"],
    size: ["1000ml", "2000ml", "3000ml"],
    types:[""]
  },
  {
    id: 2,
    category: 'medical-gas',
    name: 'Bed Head Panel',
    description: 'Integrated unit providing essential medical gas and electrical connections.',
    features: [
      'Multiple gas outlets',
      'Electrical sockets',
      'LED lighting',
      'Nurse call system integration',
    ],
    image: '/images/products/bed-head-panel.jpg',
    details: 'Our Bed Head Panels offer a comprehensive solution for patient care areas, integrating medical gas outlets, electrical power sockets, and efficient LED lighting. Designed for safety and convenience, these panels can also integrate with nurse call systems, providing essential services readily accessible to patients and medical staff.',
    specifications: ["HB-2512"],
    size: ["900mm", "1200mm", "1500mm"],
    types:["Round type","Square type","Rectangular type", "Circular type", "Horizontal type", "Vertical type"]
  },
  {
    id: 3,
    category: 'medical-gas',
    name: 'Air Compressor',
    description: 'Medical-grade copper tubes for gas pipeline systems.',
    features: [
      'High-purity copper',
      'Degreased interior',
      'Various sizes available',
      'HTM 02-01 compliant',
    ],
    image: '/images/products/air-compressor.jpg',
    details: "Medical air compressors are essential devices in hospitals and clinics, supplying clean, compressed air for various critical applications. They are used in respiratory therapy to assist patients with breathing, in anesthesia machines to deliver gases, and to power surgical instruments. Unlike industrial compressors, medical air compressors must meet strict hygiene and safety standards to ensure the air is free from contaminants, oil, and moisture. These systems often include filtration units, dryers, and backup capabilities to ensure a reliable air supply at all times. Medical air is classified as a pharmaceutical product, so its production and delivery must comply with stringent regulations, such as those from the NFPA and ISO. Commonly installed in centralized systems, these compressors distribute medical air throughout the facility via a dedicated pipeline. Their reliability and purity are vital for patient safety, making regular maintenance and monitoring critical components of their operation. Medical air is an essential component in modern healthcare facilities, used for respiratory support, powering surgical tools, and various therapeutic applications. To ensure continuous and safe delivery of high-quality compressed air, hospitals and clinical facilities must rely on robust, reliable, and precisely engineered medical air compressor systems. This document outlines comprehensive technical requirements for medical air compressors intended for hospital use, with a focus on system design, operational flexibility, redundancy, quality control, and integration with hospital-wide alarm systems.",
    specifications: ["HB-2512"],
    size: ["900mm", "1200mm", "1500mm"]
  },
  {
    id: 4,
    category: 'medical-gas',
    name: 'Automatic Gas Control Panel/Reductions Station',
    description: 'Medical gas terminal units compliant with international standards.',
    features: [
      'Pressure gauges for monitoring input and output pressures from both banks',
      'Alarm systems to indicate bank depletion, overpressure, or failure',
      'LED status indicators for bank-in-use, reserve, and fault conditions',
      'Built-in filters to trap contaminants before gas enters the hospital distribution system',
      'Remote signal output for integration with the central alarm and Building Management Systems (BMS)',
    ],
    image: '/images/products/automatic-gas-control-panel.jpg',
    details: 'The Automatic Gas Control Panel is a critical component in centralized medical gas pipeline systems, enabling safe and continuous delivery of gases like oxygen, nitrous oxide,CO2. It manages the connection, regulation, and changeover between two high-pressure gas cylinder banks—commonly referred to as the Left Bank and Right Bank—ensuring uninterrupted gas flow to the hospital distribution system.',
    specifications: ["HB-2514"],
    size: [],
    types: []
  },
  {
    id: 5,
    category: 'medical-gas',
    name: 'Air Dryers/Air Filters',
    description: 'Complete medical gas pipeline infrastructure with high-grade materials.',
    features: [
      'Seamless integration',
      'Pressure regulators',
      'Alarm systems compatibility',
      'Customizable configurations',
    ],
    image: '/images/products/air-dryers.jpg',
    details: 'We offer complete medical gas pipeline infrastructure solutions using high-grade materials and precise installation techniques. Our systems ensure seamless integration with existing hospital infrastructure, featuring advanced pressure regulators and compatibility with various alarm systems. Customizable configurations allow for tailored solutions to meet specific facility requirements.',
    specifications: [],
    size: [],
    types: []
  },
  {
    id: 6,
    category: 'medical-gas',
    name: 'Air Receiving Vessels',
    description: 'Advanced monitoring systems for safe operation of medical gas supply.',
    features: [
      'Real-time alerts',
      'Multiple alarm levels',
      'Remote monitoring capability',
      'Battery backup',
    ],
    image: '/images/products/air-receiving-vessels.jpg',
    details: 'Our advanced Gas Alarm Systems provide continuous monitoring of medical gas supply, ensuring safe operation with real-time alerts. Featuring multiple alarm levels and remote monitoring capabilities, these systems offer comprehensive safety oversight. Equipped with battery backup, they guarantee uninterrupted operation during power outages, providing peace of mind for critical healthcare operations.',
    specifications: [],
    size: [],
    types: []
  },
  {
    id: 7,
    category: 'medical-gas',
    name: 'Medical Vacuum System',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Vacuum level between -600 to -700 mmHg (80–93% vacuum)",
      "Pump configuration: minimum 2 duty + 1 standby (N+1 redundancy)",
      "Continuous duty operation with automatic alternation",
      "3-phase, 415V, 50 Hz power supply (or country standard)",
      "Receiver tank sized for 5 minutes of peak flow demand",
      "PLC-based control panel with automatic sequencing and alarm integration",
      "Integrated alarms for high temperature, low vacuum, motor overload, and filter blockage",
      "99.97% efficient HEPA-grade bacteria filtration system",
      "Automatic condensate drain with non-return protection",
      "Compliant with ISO 7396-1, HTM 02-01, AS/NZS 2896, and NFPA 99 standards",
      "Automatic duty cycling to balance wear across pumps",
      "Auto-start and stop based on real-time demand",
      "Local and central hospital alarm integration",
      "Noise and vibration isolation with anti-vibration mounting",
      "Easy access for maintenance, inspection, and cleaning",
      "Supports multiple pump types: oil-sealed rotary vane, oil-free scroll, and screw vacuum pumps",
      "Suitable for continuous, large-scale hospital applications",
      "Oil-free options available for cleaner discharge and low maintenance",
      "Energy-efficient and quiet screw vacuum pumps for high-demand facilities"
  ],
    image: '/images/products/medical-vacuum-system.jpg',
    details: 'Model No: HB-2515 is a high-performance vacuum system designed for critical hospital environments such as surgeries, ICU, and wound care. Engineered for continuous, reliable operation, it meets international healthcare standards like ISO 7396-1 and HTM 02-01. The system features N+1 redundancy, advanced PLC-based control panels, bacteria filtration, and noise/vibration isolation to ensure safety, hygiene, and minimal downtime. It supports multiple pump types including oil-free and energy-efficient options, making it suitable for both small clinics and large hospitals.',
    specifications: ["HB-2515"],
    size: [],
    types: []
  },
  {
    id: 8,
    category: 'medical-gas',
    name: 'Vacuum Bacterial filter',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features: [
      'Integrated controls',
      'Pressure monitoring',
      'Flow meters',
      'Emergency shut-off',
    ],
    image: '/images/products/vacuum-bacterial-filter.jpg',
    details: 'Our Operation Theatre Panels are comprehensive control units designed for efficient management of medical gas supply in surgical environments. They feature integrated controls for various medical gases, precise pressure monitoring, and accurate flow meters. An emergency shut-off mechanism is included for enhanced safety, ensuring optimal conditions during critical procedures.',
    specifications: [],
    size: [],
    types: []
  },
  {
    id: 9,
    category: 'medical-gas',
    name: 'Vacuum Vessels',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features: [
      'Integrated controls',
      'Pressure monitoring',
      'Flow meters',
      'Emergency shut-off',
    ],
    image: '/images/products/vacuum-vessels.jpg',
    details: 'Our Operation Theatre Panels are comprehensive control units designed for efficient management of medical gas supply in surgical environments. They feature integrated controls for various medical gases, precise pressure monitoring, and accurate flow meters. An emergency shut-off mechanism is included for enhanced safety, ensuring optimal conditions during critical procedures.',
    specifications: [],
    size: [],
    types: []
  },
  {
    id: 9,
    category: 'medical-gas',
    name: 'Vacuum Vessels',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features: [
      'Integrated controls',
      'Pressure monitoring',
      'Flow meters',
      'Emergency shut-off',
    ],
    image: '/images/products/vacuum-vessels.jpg',
    details: 'Our Operation Theatre Panels are comprehensive control units designed for efficient management of medical gas supply in surgical environments. They feature integrated controls for various medical gases, precise pressure monitoring, and accurate flow meters. An emergency shut-off mechanism is included for enhanced safety, ensuring optimal conditions during critical procedures.'
  },
  {
    id: 10,
    category: 'medical-gas',
    name: 'Ward Vacuum Units',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Wall-mounted or portable",
      "Connected to a central vacuum source",
      "Controlled via regulators and suction jars",
      "Essential for emergency and surgical care"
  ]
  ,
    image: '/images/products/ward-vacuum-units.png',
    details: "A Ward Vacuum in a hospital setting refers to a central suction system installed in patient care areas (wards). It’s used for medical procedures such as removing fluids, blood, or mucus from a patient’s airway or surgical site. It is an essential component of medical infrastructure, used to remove fluids, blood, mucus, or other secretions from a patient's airway or surgical site. The system typically includes wall-mounted suction outlets connected to a central vacuum pump, with regulators and collection jars for controlled operation. Ward Vacuums play a vital role in emergency response, post-operative care, and routine medical procedures, ensuring a sterile environment and helping maintain airway patency in critically ill or surgical patient.",
    specifications: ["HB-2516"],
    size: [],
    types: []
  },
  {
    id: 11,
    category: 'medical-gas',
    name: 'Gas Manifold System, Pig Tail & NRVs for manifold',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Used in operating theatres for anesthesia delivery (e.g., nitrous oxide, oxygen)",
      "Supports ICUs and patient wards with oxygen therapy and respiratory support",
      "Provides immediate access to lifesaving gases in emergency rooms",
      "Delivers controlled oxygen for sensitive patients in neonatal and pediatric units",
      "Supplies medical air for ventilators and pneumatic medical tools"
  ]
  ,
    image: '/images/products/gas-manifold-system.jpg',
    details: 'A gas manifold system in a hospital is a centralized system used to supply medical gases—such as oxygen, nitrous oxide, and medical air—from large storage cylinders or liquid sources to different areas of the facility. It typically consists of a series of interconnected gas cylinders or tanks regulated through a control panel and piping network. The manifold ensures a continuous and safe gas supply by automatically switching between primary and reserve gas sources when pressure drops. These systems are critical in operating rooms, intensive care units, and patient wards, where consistent and reliable gas delivery is vital for patient care.',
    specifications: ["HB-2517"],
    size: [],
    types: []
  },
  {
    id: 12,
    category: 'medical-gas',
    name: 'Gas Supervision System',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features: [
      'Integrated controls',
      'Pressure monitoring',
      'Flow meters',
      'Emergency shut-off',
    ],
    image: '/images/products/gas-supervision-system.jpg',
    details: 'Our Operation Theatre Panels are comprehensive control units designed for efficient management of medical gas supply in surgical environments. They feature integrated controls for various medical gases, precise pressure monitoring, and accurate flow meters. An emergency shut-off mechanism is included for enhanced safety, ensuring optimal conditions during critical procedures.'
  },
  {
    id: 13,
    category: 'medical-gas',
    name: 'Anti-Static High Pressure Tube',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Prevents static discharge for safe gas transport",
      "Durable construction suitable for high-pressure environments",
      "Flexible and kink-resistant for easy handling",
      "Compliant with international medical safety standards",
      "Used for connecting gas cylinders to manifold systems",
      "Supplies gases to anesthesia machines",
      "Transfers medical gases to ventilators and patient outlets"
  ],
    image: '/images/products/anti-static-high-pressure.jpg',
    details: 'An Anti-Static High Pressure Tube is a specialized medical-grade tubing designed for the safe transportation of high-pressure gases like oxygen and nitrous oxide within hospital environments. Built with anti-static materials, it minimizes the risk of electrical discharge, ensuring safety when handling flammable or pressurized gases. Its flexibility, durability, and compliance with medical standards make it essential in critical care and surgical applications.',
    specifications: ["HB-2517"],
    size: [],
    types: []
  },
  {
    id: 14,
    category: 'medical-gas',
    name: 'Master Alarm',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Centralized monitoring of medical gas systems including oxygen, nitrous oxide, air, vacuum, and CO₂",
      "Real-time detection of gas pressure loss, leaks, or equipment failure",
      "Visual and audible alarms for immediate fault alerts",
      "Monitors gas supply levels and system performance continuously",
      "Installed in strategic hospital locations like nurse stations or maintenance rooms",
      "Alerts staff to low gas cylinder levels or pipeline malfunctions",
      "Improves patient safety through early fault detection",
      "Facilitates fast response to emergencies or system issues",
      "Enhances system reliability and minimizes operational downtime",
      "Provides centralized control for efficient gas system management"
  ],
    image: '/images/products/master-alarm.jpg',
    details: 'The Master Alarm System is a centralized monitoring panel designed to supervise hospital-wide medical gas pipeline systems, including oxygen, nitrous oxide, medical air, vacuum, and carbon dioxide. Installed in key locations like maintenance rooms or nurse stations, it provides real-time alerts—both visual and audible—for any pressure drops, leaks, or equipment malfunctions. This system is critical for ensuring continuous gas supply, rapid fault detection, and coordinated maintenance, enhancing both patient safety and hospital efficiency.',
    specifications: ["HB-2518"],
    size: [],
    types: []
  },
  {
    id: 15,
    category: 'medical-gas',
    name: 'Gas Outlet/Terminal Unit',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Provides access to medical gases like oxygen, air, nitrous oxide, and vacuum",
      "Mounted on walls, ceiling pendants, or bedhead panels in clinical environments",
      "Gas-specific, color-coded, and keyed to prevent cross-connection errors",
      "Supports secure, quick connections using standard gas probes",
      "Enables delivery of oxygen or air via flowmeters or masks",
      "Facilitates connection to anesthesia machines during surgeries",
      "Used for suction devices in airway clearance or medical procedures",
      "Powers pneumatic medical equipment reliably",
      "Includes various types: BS, Amico, DIN, PB, Omeda, AGSS outlets",
      "Compact and robust design for ICUs, ORs, ERs, and patient wards",
      "Improves safety and efficiency in gas distribution",
      "Ensures immediate access to life-supporting medical gases"
  ],
    image: '/images/products/gas-outlet.jpg',
    details: 'A Gas Outlet or Terminal Unit is an essential access point in a hospital’s medical gas pipeline system, allowing healthcare staff to safely and efficiently connect medical equipment such as ventilators, anesthesia machines, and oxygen masks. These outlets are gas-specific, color-coded, and mechanically keyed to prevent misconnections. Typically mounted on walls, ceiling pendants, or bedhead panels, they ensure immediate and secure access to critical gases like oxygen, medical air, nitrous oxide, and vacuum. Their quick-connect design supports rapid response and streamlined medical workflows.',
    specifications: ["HB-2519"],
    size: [],
    types: [
      "BS Gas Outlets",
      "Amico Gas Outlets",
      "DIN Gas Outlets",
      "PB Gas Outlets",
      "Omeda Gas Outlets",
      "AGSS Gas Outlets"
  ]
  },
  {
    id: 16,
    category: 'medical-gas',
    name: 'Ceiling Pendant',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Delivers medical gases (oxygen, vacuum, etc.) and electrical power to life-support devices",
      "Supports critical care equipment like ventilators, monitors, infusion pumps, and surgical tools",
      "Organizes tubing and cables to reduce clutter and improve safety",
      "Ceiling-mounted design enhances floor accessibility and infection control",
      "Enables ergonomic positioning of equipment around the patient",
      "Improves workflow efficiency and patient care during surgeries and emergencies",
      "Reduces tripping hazards by eliminating floor-based equipment stands",
      "Available in fixed or flexible arm configurations",
      "Often includes gas outlets, electrical sockets, drawers, and shelves",
      "Suitable for ICUs, operating rooms, emergency rooms, and recovery areas"
  ],
    image: '/images/products/ceiling-pendant.jpg',
    details: 'A Ceiling Pendant is a ceiling-mounted unit used in hospitals to organize and deliver essential utilities—such as medical gases, power, and data—to critical care areas like ICUs, operating rooms, and emergency departments. By suspending equipment and managing cables, it helps declutter floors, improves accessibility, and supports infection control. Ceiling pendants can be fixed or articulated, allowing flexible positioning of equipment and enhancing workflow efficiency in high-pressure medical environments.',
    specifications: ["HB-2520"],
    size: [],
    types: [
      "Single-arm pendant",
      "Double-arm pendant",
      "Fixed pendant",
      "ICU pendant"
  ]
  },
  {
    id: 17,
    category: 'medical-gas',
    name: 'AVSU(with Integrated Alarm Panel)',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Controls and isolates medical gas flow to specific hospital zones",
      "Equipped with individual shut-off valves for each gas line",
      "Includes pressure gauges for real-time gas pressure monitoring",
      "Allows quick gas shut-off during emergencies or maintenance",
      "Wall-mounted and enclosed in a labeled, transparent-front box",
      "Improves patient and staff safety during fire or gas leak scenarios",
      "Simplifies maintenance by isolating zones without affecting full supply",
      "Supports compliance with international healthcare gas safety standards",
      "Ideal for ICUs, operating theatres, patient wards, and recovery rooms",
      "Supports integration with alarm systems for added safety"
  ],
    image: '/images/products/avsu.jpg',
    details: 'An AVSU (Area Valve Service Unit), also known as a Zonal Valve Box, is a vital safety device in a hospital’s medical gas pipeline system. It allows localized control and isolation of gases like oxygen, nitrous oxide, medical air, and vacuum within specific zones such as ICUs, OTs, and wards. Wall-mounted and enclosed with a clear cover, it contains shut-off valves, pressure gauges, and sometimes alarms, enabling fast intervention during maintenance, emergencies, or renovations without disrupting hospital-wide gas supply.',
    specifications: ["HB-2521"],
    size: [],
    types: []
  },
  {
    id: 18,
    category: 'medical-gas',
    name: 'Oxygen flow mater, BPC, Flow meter, Suction Unit',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Measures and regulates oxygen flow rate accurately in LPM",
      "Features a transparent tube with a floating bobbin or ball for easy reading",
      "Equipped with a precision control valve for flow adjustment",
      "Can be mounted on wall gas outlets or portable oxygen cylinders",
      "Used for delivering oxygen therapy through masks, cannulas, or tents",
      "Compatible with humidifiers to provide moist oxygen for comfort",
      "Commonly used in emergency rooms, ICUs, and general wards",
      "Easy to operate by both medical and support staff",
      "Durable and reliable for continuous clinical use",
      "Designed with British Pattern Connector (BPC) standards"
  ],
    image: '/images/products/oxygen-flow-mater.jpg',
    details: 'An Oxygen Flow Meter, also known as a BPC Flowmeter (British Pattern Connector), is a precision medical device designed to regulate and measure the flow rate of oxygen from a centralized gas supply or cylinder to the patient. Featuring a transparent, graduated tube with a bobbin or ball indicator, it provides accurate flow readings in liters per minute (LPM). Mounted on wall outlets or oxygen cylinders, it plays a vital role in oxygen therapy across various hospital departments, often used in conjunction with humidifiers for patient comfort.',
    specifications: ["HB-2522"],
    size: [],
    types: []
  },
  {
    id: 19,
    category: 'medical-gas',
    name: 'Isolation Valve',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Manually isolates medical gas flow in specific hospital zones",
      "Used for oxygen, nitrous oxide, medical air, and vacuum lines",
      "Installed at floor, ward, or department level for targeted control",
      "Allows maintenance or repairs without shutting down entire system",
      "Essential for emergency gas shut-off in case of leaks or fire",
      "Improves operational safety and response in high-risk zones",
      "Clearly labeled and placed in visible, accessible locations",
      "Supports renovations and partial closures without disrupting supply",
      "Enhances system flexibility and efficiency during service procedures",
      "Complies with healthcare facility safety standards and regulations"
  ],
    image: '/images/products/isolation-valve.jpg',
    details: 'An Isolation Valve is a key safety and control component in a hospital’s medical gas pipeline system, designed to manually shut off or isolate the flow of gases such as oxygen, nitrous oxide, and vacuum in specific areas. Strategically placed at floor, ward, or departmental levels, these valves enable targeted maintenance, emergency shut-off, or zone control without affecting the hospital-wide supply. Clearly labeled and easily accessible, isolation valves are essential for safety, operational efficiency, and compliance with healthcare regulations.',
    specifications: ["HB-2523"],
    size: [],
    types: []
  },
  {
    id: 20,
    category: 'medical-gas',
    name: 'Pressure Regulators',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Reduces high-pressure medical gases to safe, usable levels",
      "Ensures stable and consistent gas delivery to clinical equipment",
      "Protects patients from high-pressure gas exposure",
      "Prevents damage to sensitive devices like ventilators and anesthesia machines",
      "Delivers precise pressure for oxygen therapy and surgical procedures",
      "Minimizes gas wastage, improving efficiency and reducing cost",
      "Compatible with both central gas pipeline systems and individual gas cylinders",
      "Supports critical functions in ICUs, operating theatres, and emergency rooms",
      "Improves equipment lifespan by preventing pressure surges",
      "Essential for maintaining safe and regulated clinical gas flow"
  ],
    image: '/images/products/pressure-regulators.jpg',
    details: 'A Pressure Regulator is a vital component in hospital medical gas systems, responsible for reducing and stabilizing high-pressure gases—such as oxygen, nitrous oxide, or medical air—to safe, usable levels. Installed on gas cylinders or integrated within pipeline systems, it ensures a consistent and controlled pressure supply to life-support equipment like ventilators and anesthesia machines. By maintaining precise pressure delivery, it safeguards both patients and sensitive medical equipment while optimizing gas consumption.',
    specifications: ["HB-2524"],
    size: [],
    types: []
  },
  {
    id: 21,
    category: 'medical-gas',
    name: 'Copper Pipe',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Transports oxygen, nitrous oxide, vacuum, and other medical gases safely",
      "Constructed from medical-grade, degreased copper for contamination-free gas delivery",
      "Corrosion-resistant to ensure long-term reliability and system integrity",
      "Non-reactive with medical gases to maintain purity and patient safety",
      "Strong and durable material suitable for high-pressure and high-temperature environments",
      "Easily sterilized and compliant with hospital hygiene standards",
      "Supports both new MGPS installations and retrofit projects",
      "Forms the backbone of the medical gas pipeline network across hospital zones",
      "Connects central gas supply sources to patient care areas like ICUs and OTs",
      "Complies with international healthcare standards (e.g., HTM 02-01, NFPA 99)"
  ],
    image: '/images/products/copper-pipe.jpeg',
    details: 'Copper pipes are the industry-standard material used in hospital Medical Gas Pipeline Systems (MGPS) for the safe and efficient transport of medical gases such as oxygen, nitrous oxide, vacuum, medical air, and carbon dioxide. Constructed from medical-grade, degreased copper, these pipes are free of oil, grease, and contaminants to ensure gas purity and patient safety. Renowned for their corrosion resistance, strength, and sterility, copper pipes are ideal for both new installations and retrofitting in critical healthcare environments.',
    specifications: ["HB-2525"],
    size: [],
    types: []
  },
  {
    id: 22,
    category: 'medical-gas',
    name: 'Area Alarm Panel',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Monitors real-time gas pressure within a specific hospital zone",
      "Displays gas levels for oxygen, nitrous oxide, medical air, vacuum, and carbon dioxide",
      "Triggers audible and visual alarms when gas pressure is outside safe limits",
      "Installed at nurse stations or department entrances for easy visibility",
      "Improves patient safety by detecting gas issues early",
      "Helps maintenance teams identify faults quickly",
      "Supports emergency response by highlighting affected gas lines",
      "Enables localized monitoring to prevent hospital-wide disruptions",
      "Easy-to-read interface for both clinical and technical staff",
      "Compliant with international medical gas safety standards"
  ],
    image: '/images/products/area-alerm-panel.jpg',
    details: 'An Area Alarm Panel is a vital hospital device that monitors the status of medical gas systems within a specific department or zone—such as ICUs, operating rooms, or patient wards. It provides real-time digital pressure readings for gases like oxygen, medical air, nitrous oxide, vacuum, and carbon dioxide. Equipped with both visual and audible alarms, it alerts staff instantly if gas pressures fall outside safe operating ranges. Typically mounted near nurse stations or department entrances, the panel enhances localized safety, operational awareness, and rapid emergency response.',
    specifications: ["HB-2526"],
    size: [],
    types: []
  },
  {
    id: 23,
    category: 'medical-gas',
    name: 'Anaesthesia Gas Scavenging System',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Captures waste anaesthetic gases during surgical procedures",
      "Protects healthcare staff from prolonged exposure to harmful gases",
      "Maintains safe air quality in operating and recovery rooms",
      "Prevents environmental contamination from residual medical gases",
      "Includes gas collection assembly, transfer tubing, interface unit, and evacuation system",
      "Supports both active (suction-based) and passive (vented) evacuation types",
      "Complies with occupational health and safety standards",
      "Promotes a safer and healthier working environment for anaesthesia providers",
      "Reduces long-term health risks associated with gas inhalation",
      "Enhances overall ventilation efficiency in closed medical spaces"
  ],
    image: '/images/products/anaesthesia-gas-scavenging-system.png',
    details: 'The Anaesthesia Gas Scavenging System (AGSS) is a critical safety system used in operating rooms to collect and remove excess or waste anaesthetic gases—such as nitrous oxide and halogenated agents—that escape during surgical procedures. These systems prevent the buildup of harmful gases in the operating environment, protecting healthcare staff from long-term exposure. AGSS typically includes a gas collection assembly, transfer tubing, an interface unit, and an active or passive evacuation system that ensures safe disposal of residual gases in compliance with health and safety regulations.',
    specifications: ["HB-2527"],
    size: [],
    types: []
  },
  {
    id: 24,
    category: 'medical-gas',
    name: 'LMO Tank/PSA Plant',
    description: 'Comprehensive control panels for managing medical gas supply.',
    features : [
      "Centralized oxygen supply for ICUs, OTs, wards, and emergency rooms",
      "LMO tanks store cryogenic liquid oxygen and convert it to gas for pipeline use",
      "PSA plants generate oxygen onsite from ambient air using filtration technology",
      "Ensures consistent, high-volume oxygen availability for critical care",
      "Supports life-saving equipment like ventilators and anesthesia machines",
      "Maintains high-purity oxygen output (typically 93–99%)",
      "Reduces dependency on external oxygen cylinder deliveries",
      "Improves hospital self-sufficiency in remote or high-demand locations",
      "Enables cost-effective, scalable oxygen infrastructure for all facility sizes",
      "Serves as primary or backup oxygen source depending on configuration"
  ],
    image: '/images/products/lmo-tank.jpg',
    details: 'LMO Tanks (Liquid Medical Oxygen Tanks) and PSA Plants (Pressure Swing Adsorption Plants) are essential oxygen supply systems used in hospitals. LMO Tanks store oxygen in liquid form at cryogenic temperatures and vaporize it for pipeline distribution, while PSA Plants generate oxygen onsite by extracting it from ambient air using molecular sieves. Together, these systems ensure a steady, high-purity oxygen supply for critical medical areas such as ICUs, operating theatres, and emergency rooms. They are especially vital during emergencies and high-demand scenarios like pandemics, offering hospitals operational independence and supply reliability.',
    specifications: ["HB-2528"],
    size: [],
    types: []
  },
  {
    id: 0,
    category: 'medical-gas',
    name: 'MGPS Other Equipment Details',
    image: '',
    description: 'Liquid Medical Oxygen (LMO) tank for bulk oxygen storage.',
    features: [
      'Large capacity',
      'Insulated design',
      'Safe storage',
    ],
    details: 'Our Operation Theatre Panels are comprehensive control units designed for efficient management of medical gas supply in surgical environments. They feature integrated controls for various medical gases, precise pressure monitoring, and accurate flow meters. An emergency shut-off mechanism is included for enhanced safety, ensuring optimal conditions during critical procedures.'
  },
  {
    id: 25,
    category: 'modular-operation-theatre',
    name: 'Prefabricated Walls & Ceiling Panel-SS/SMS/GI/EGP',
    description: 'High-quality SS304 panels for durable and hygienic wall and ceiling applications.',
    features : [
      "Used in modular construction of OTs, ICUs, labs, and clean rooms",
      "Supports cleanroom-grade walls and ceilings for pharma and diagnostic zones",
      "Enables quick and disruption-free hospital upgrades",
      "Prefabricated panels ensure high-quality finishes and fast installation",
      "Smooth, seamless surfaces allow easy cleaning and disinfection",
      "Improves infection control by minimizing microbial growth",
      "Offers thermal, acoustic, and fire resistance depending on panel material",
      "Available in multiple material types for sterile and semi-sterile areas",
      "Customizable and expandable to fit different hospital zones",
      "Low-maintenance and durable for long-term hospital use"
  ],
    image: '/images/products/prefabricated-walls.jpg',
    details: 'Prefabricated walls and ceiling panels are modular construction elements used in hospitals to build high-performance environments such as Operating Theatres (OTs), ICUs, labs, and clean rooms. These panels are manufactured off-site and installed quickly on-site, providing superior finish quality, hygiene, and infection control. Available in materials like stainless steel (SS), sandwich panels (SMS), galvanized iron (GI), and epoxy-coated GI (EGP), they meet diverse structural, thermal, and clinical needs. Prefab systems reduce installation time, minimize disruption to hospital operations, and ensure compliance with healthcare standards.',
    specifications: [],
    size: [],
    types : [
      "Stainless Steel (SS)",
      "Sandwich Panel (SMS)",
      "Galvanized Iron (GI)",
      "Epoxy-Coated GI (EGP)"
  ]  
  },
  {
    id: 26,
    category: 'modular-operation-theatre',
    name: 'Anti-bacterial/Anti-fungal Paint',
    description: 'Specialized paint for walls and ceilings with anti-bacterial and anti-fungal properties.',
    features : [
      "Prevents bacterial, mold, and fungal growth on painted surfaces",
      "Contains biocidal agents or silver ion-based antimicrobial technology",
      "Applied to walls and ceilings in sterile and semi-sterile hospital zones",
      "Improves hygiene in ICUs, OTs, isolation rooms, labs, and washrooms",
      "Helps reduce infection risk for patients, staff, and visitors",
      "Durable and washable – withstands frequent cleaning with disinfectants",
      "Low-VOC and odorless – safe for use in occupied healthcare areas",
      "Suitable for both new hospital construction and renovation projects",
      "Complies with healthcare-grade hygiene and safety standards",
      "Enhances the longevity and cleanliness of hospital infrastructure"
  ],
    image: '/images/products/anti-bacterial.jpg',
    details: 'Anti-bacterial and anti-fungal paint is a specialized wall and ceiling coating designed for use in hospitals and healthcare environments to prevent the growth of harmful microorganisms such as bacteria, mold, and fungi. Formulated with biocidal agents or silver ion technology, this paint offers long-lasting microbial protection on contact. Ideal for sterile and semi-sterile zones like ICUs, operating theatres, isolation rooms, and labs, it helps improve hygiene and reduce infection risks. These paints are typically washable, odorless, low-VOC, and safe for indoor use.',
    specifications: [],
    size: [],
    types: []
  
  },
  {
    id: 27,
    category: 'modular-operation-theatre',
    name: 'Laminar Air Flow System',
    description: 'Seamless PVC flooring designed for easy cleaning and hygiene.',
    features : [
      "Delivers unidirectional laminar flow of HEPA-filtered sterile air",
      "Reduces airborne contamination in surgical and cleanroom environments",
      "Maintains ultra-clean air conditions during critical hospital procedures",
      "Flushes out particles and microorganisms continuously",
      "Available in vertical or horizontal airflow configurations",
      "Used in OTs, ICUs, cleanrooms, labs, and pharmacies",
      "Minimizes surgical site infections (SSIs) and contamination risks",
      "Supports aseptic and sterile work zones in medical and biotech areas",
      "Improves patient safety and procedural outcomes",
      "Equipped with HEPA filters offering 99.97% particle removal efficiency"
  ],
    image: '/images/products/laminar-air-flow-system.jpg',
    details: 'A Laminar Air Flow (LAF) System is a high-efficiency air purification system designed for sterile environments within hospitals, such as operating theatres, ICUs, cleanrooms, and laboratories. It delivers a continuous, unidirectional stream of HEPA-filtered air—either vertically or horizontally—to flush out airborne particles, bacteria, and contaminants. This creates an ultra-clean environment over surgical fields or sensitive workstations, dramatically reducing infection risks and supporting critical procedures like surgeries, transplants, and pharmaceutical operations.',
    specifications: [],
    size: [],
    types: []
  
  },
  {
    id: 28,
    category: 'modular-operation-theatre',
    name: 'Conductive Seamless Flooring with Coving on all Corners',
    description: 'System for maintaining clean airflow in critical environments.',
    features : [
      "Used in OTs, ICUs, cath labs, isolation rooms, and cleanrooms",
      "Electrically conductive surface prevents static discharge",
      "Ideal for areas with sensitive medical or diagnostic equipment",
      "Seamless and joint-free flooring reduces microbial growth",
      "Integrated coving at wall junctions improves hygiene",
      "Supports sterile, dust-free environments in labs and diagnostic centers",
      "Durable and resistant to hospital-grade chemicals and disinfectants",
      "Easy to clean and maintain, suitable for frequent deep cleaning",
      "Enhances infection control and meets healthcare safety standards",
      "Compliant with medical facility design and electrostatic control requirements"
  ],
    image: '/images/products/conductive-seamless-flooring.jpg',
    details: 'Conductive seamless flooring with coving is a specialized, high-performance flooring solution used in critical hospital zones such as Operation Theatres (OTs), ICUs, labs, and cleanrooms. Made from anti-static, electrically conductive materials like epoxy or vinyl, this flooring prevents static electricity buildup while offering a smooth, joint-free surface for superior hygiene. The integrated coving—where the flooring curves upward at wall junctions—eliminates sharp corners, preventing dirt accumulation and supporting strict infection control protocols.',
    specifications: [],
    size: [],
    types: []
  
  },
  {
    id: 29,
    category: 'modular-operation-theatre',
    name: 'Hermetically Sealed Sliding Door System',
    description: 'LED fittings designed for clean rooms and peripheral lighting.',
    features : [
      "Creates an airtight seal to control air pressure and reduce contamination",
      "Used in OTs, ICUs, isolation rooms, labs, and cleanrooms",
      "Prevents cross-contamination by limiting airborne particle transfer",
      "Supports sterile and controlled environments in critical hospital zones",
      "Equipped with rubber gaskets or pressure sealing mechanisms",
      "Made from hygienic, durable materials like stainless steel or HPL",
      "Offers touch-free access with optional automatic sliding operation",
      "Easy to clean and maintain for infection-sensitive environments",
      "Improves energy efficiency by minimizing conditioned air loss",
      "Enhances patient safety and compliance with hospital infection control standards"
  ],
    image: '/images/products/hermetically-sealed-sliding-door-system.jpg',
    details: 'A Hermetically Sealed Sliding Door System is a precision-engineered hospital door designed to create an airtight seal, reducing air leakage and preventing the spread of airborne contaminants. These doors are commonly installed in Operating Theatres (OTs), ICUs, isolation rooms, labs, and cleanrooms where maintaining sterile conditions is critical. Built from hygienic, durable materials like stainless steel or high-pressure laminate (HPL), they often feature automated, touchless operation for enhanced infection control and hands-free access in sensitive healthcare areas.',
    specifications: [],
    size: [],
    types: []
  
  },
  {
    id: 30,
    category: 'modular-operation-theatre',
    name: 'Surgeon Control Panel',
    description: 'Automatic sliding doors for convenient and hygienic access.',
    features : [
      "Centralized control for OT lighting, HVAC, and laminar airflow systems",
      "Real-time monitoring of medical gas alarms and pressure indicators",
      "Integrates with surgical timers, digital clocks, and intercom systems",
      "Supports touch-enabled or hands-free operation for sterile environments",
      "Constructed with stainless steel or antimicrobial glass for easy cleaning",
      "Minimizes staff movement, preserving the sterile surgical zone",
      "Enhances safety and precision through quick access to critical controls",
      "Improves workflow efficiency and surgical coordination",
      "Customizable layout and features based on OT configuration",
      "Complies with hospital safety and infection control standards"
  ],
    image: '/images/products/surgeon-control-panel.jpg',
    details: 'A Surgeon Control Panel is a wall-mounted, integrated interface installed in Operating Theatres (OTs) to centralize the control of critical room functions. Designed using materials like stainless steel or antimicrobial glass for easy sterilization, the panel allows surgeons and staff to adjust lighting, HVAC, laminar airflow, gas alarms, timers, and communication systems—all without compromising the sterile field. This system enhances surgical efficiency, safety, and hygiene by reducing unnecessary movement and enabling real-time control of essential operations.',
    specifications: [],
    size: [],
    types: []
  
  },
  {
    id: 31,
    category: 'modular-operation-theatre',
    name: 'X-Ray View Screen',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Used to view X-ray, CT scan, and MRI films with high clarity",
      "Backlit with bright, uniform LED or fluorescent lighting",
      "Mounted in OTs, radiology, outpatient, trauma, orthopedic, and dental units",
      "Assists in diagnosis, surgical planning, and medical education",
      "Provides consistent, shadow-free illumination across the entire screen",
      "Supports quick clinical decisions in emergency and surgical settings",
      "Slim, wall-mountable design ideal for compact clinical environments",
      "Energy-efficient models available with long service life (especially LED)",
      "Durable, low-maintenance construction for frequent use",
      "Essential for radiologists, surgeons, and clinicians reviewing diagnostic films"
  ],
    image: '/images/products/x-ray-view-screen.jpg',
    details: 'An X-Ray View Screen, also called a Film Illuminator or X-ray Viewer, is a wall-mounted or portable device used in hospitals to display radiographic films such as X-rays, CT scans, and MRIs. It features a uniformly backlit, translucent screen—typically powered by LED or fluorescent light—to provide clear visibility of diagnostic images. Commonly used in operating theatres, radiology departments, and outpatient clinics, this device helps medical professionals interpret films accurately and make informed decisions during surgeries and treatments.',
    specifications: [],
    size: [],
    types: []
  
  },
  {
    id: 32,
    category: 'modular-operation-theatre',
    name: 'Writing White Board',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Used to display patient care information, surgery schedules, and medical instructions",
      "Mounted in patient rooms, nurse stations, ICUs, OTs, and meeting areas",
      "Made from durable, non-staining materials like glass, ceramic-coated steel, or acrylic",
      "Reusable surface for eco-friendly and cost-effective communication",
      "Supports staff coordination during rounds, shift changes, and emergency planning",
      "Functions as an educational and discussion tool in training rooms",
      "Easy to clean and disinfect, promoting hospital hygiene standards",
      "Customizable in size and layout to suit clinical and administrative needs",
      "Enhances visibility and clarity of communication among care teams",
      "Long-lasting performance in high-usage hospital environments"
  ],
    image: '/images/products/writing-white-board.jpg',
    details: 'A Writing White Board is a reusable, erasable surface installed in various hospital environments to support clinical communication, planning, and documentation. Made from materials such as laminated glass, ceramic-coated steel, or acrylic, these boards are hygienic, durable, and easy to disinfect. Commonly mounted in patient rooms, ICUs, nurse stations, OTs, and meeting rooms, they are essential for displaying patient care information, scheduling procedures, and facilitating staff coordination and education.',
    specifications: [],
    size: [],
    types: []
  
  }, 
  {
    id: 33,
    category: 'modular-operation-theatre',
    name: 'Pressure Release Damper',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Automatically regulates room pressure based on pressure differentials",
      "Used in OTs, ICUs, cleanrooms, isolation rooms, and hospital labs",
      "Maintains positive pressure in sterile environments like operating rooms",
      "Supports negative pressure containment in infectious disease wards",
      "Prevents structural damage due to excess air pressure buildup",
      "Balances airflow between sterile and non-sterile zones",
      "Improves HVAC system efficiency and reduces strain on components",
      "Operates without manual input for continuous, reliable performance",
      "Essential for maintaining air quality and infection control standards",
      "Compliant with healthcare ventilation and safety guidelines"
  ],
    image: '/images/products/pressure-release-damper.jpg',
    details: 'A Pressure Release Damper (PRD) is an automatic air control device used in hospital ventilation systems to maintain desired air pressure levels in critical areas like modular operation theatres, cleanrooms, ICUs, isolation rooms, and laboratories. It operates by opening or closing in response to pressure differentials, thereby preserving positive pressure (to keep contaminants out) or negative pressure (to contain infections), depending on the clinical requirement. By regulating air pressure passively, the PRD enhances HVAC performance and supports hospital infection control protocols.',
    specifications: [],
    size: [],
    types: []
  
  }, 
  {
    id: 34,
    category: 'modular-operation-theatre',
    name: 'Peripheral Lights (Dimmable)',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Provides ambient, indirect lighting around the perimeter of OTs and critical areas",
      "Dimmable LED lights allow adjustable brightness for different surgical phases",
      "Reduces glare and eye strain for surgeons and staff during long procedures",
      "Maintains optimal visibility without interfering with surgical field lighting",
      "Ideal for use in OTs, ICUs, recovery rooms, and procedure rooms",
      "Low heat emission helps maintain sterile room temperature control",
      "Energy-efficient and long-lasting LED technology",
      "Enhances visual comfort and reduces fatigue in high-focus zones",
      "Integrated with modular ceilings for a clean, seamless aesthetic",
      "Supports infection control through smooth, easy-to-clean surfaces"
  ],
    image: '/images/products/peripheral-lights.jpg',
    details: 'Peripheral Lights (Dimmable) are ambient lighting fixtures installed along the perimeter of Operation Theatres (OTs) and other critical care areas. Designed for indirect, glare-free illumination, they help create a calm, visually comfortable environment during surgeries and clinical procedures. These LED-based lights are dimmable, allowing medical staff to adjust brightness according to specific needs—whether during surgeries, pre-op preparation, or post-op care. Seamlessly integrated into modular ceiling systems, they support hygiene, efficiency, and surgical precision.',
    specifications: [],
    size: [],
    types: []
  
  }, 
  {
    id: 35,
    category: 'modular-operation-theatre',
    name: 'Surgeon Pendant',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Ceiling-mounted system delivering medical gases and electrical power to surgical zones",
      "Supports surgical monitors, electrosurgical units, and essential devices",
      "Reduces floor clutter to improve hygiene and mobility in the OT",
      "Equipped with articulating and rotating arms for flexible equipment positioning",
      "Organizes and manages cables, equipment trays, and control panels",
      "Improves access and workflow efficiency during surgeries",
      "Promotes infection control with off-the-floor, easy-to-clean design",
      "Constructed with antimicrobial, hospital-grade materials",
      "Customizable layout with modular components for different surgical needs",
      "Enhances safety by reducing tripping hazards and equipment interference"
  ],
    image: '/images/products/surgeon-pendant.png',
    details: 'A Surgeon Pendant is a ceiling-mounted, movable utility management system designed for Operation Theatres (OTs). It delivers organized, immediate access to essential services such as medical gases, electrical power, data ports, and lighting controls. Equipped with articulating and rotating arms, it allows surgeons to position critical equipment—like monitors, electrosurgical units, and instruments—precisely around the surgical field without creating clutter. Built from antimicrobial and easy-to-clean materials, the surgeon pendant supports sterile, ergonomic, and efficient surgical workflows.',
    specifications: [],
    size: [],
    types: []
  
  }, 
  {
    id: 36,
    category: 'modular-operation-theatre',
    name: 'Anaesthesia Pendant',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Ceiling-mounted system for anesthesia gas, power, and equipment management",
      "Delivers medical gases like oxygen, nitrous oxide, and air to anesthesia machines",
      "Supports anesthesia machines, monitors, ventilators, and suction units",
      "Flexible articulating arms allow ergonomic positioning near the patient",
      "Reduces floor clutter to improve hygiene and staff mobility",
      "Organizes cables, hoses, and devices for efficient anesthesia delivery",
      "Improves safety by minimizing equipment interference and trip hazards",
      "Constructed from antimicrobial materials for sterile environments",
      "Supports infection control with off-the-floor design",
      "Customizable configurations to suit various surgical and anesthesia needs"
  ],
    image: '/images/products/anaesthesia-pendant.jpg',
    details: 'An Anaesthesia Pendant is a ceiling-mounted medical equipment management system designed specifically for safe, efficient delivery of anesthesia in Operation Theatres (OTs). It provides centralized access to medical gases (e.g., oxygen, nitrous oxide), electrical outlets, data ports, and equipment trays, all arranged in an organized and ergonomic format. Equipped with articulating arms, it allows precise positioning of anesthesia machines and accessories, keeping the floor clutter-free and maintaining sterility around the surgical area.',
    specifications: [],
    size: [],
    types: []
  
  },
  {
    id: 37,
    category: 'modular-operation-theatre',
    name: 'Scrub Station',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Used for pre-operative hand and arm scrubbing by surgical staff",
      "Installed outside OTs, ICUs, labs, and cleanrooms to maintain sterility",
      "Hands-free operation via sensor, knee, or foot control to reduce contamination",
      "Includes automatic dispensers for water, soap, and disinfectant",
      "Often equipped with built-in timers to ensure proper scrubbing duration",
      "Constructed from stainless steel or anti-corrosive, easy-to-clean materials",
      "Supports hospital infection control and hygiene compliance protocols",
      "Prevents hospital-acquired infections (HAIs) through proper sanitization",
      "Durable, low-maintenance design suitable for frequent use",
      "Improves workflow by providing quick and sterile access to surgical teams"
  ],
    image: '/images/products/scrub-station.jpg',
    details: 'A Scrub Station is a hygienically engineered handwashing unit installed just outside Operation Theatres (OTs) and other sterile zones in hospitals. Designed for pre-operative use by surgeons and medical staff, it facilitates thorough hand and arm scrubbing under sterile conditions. Constructed from stainless steel or other corrosion-resistant materials, scrub stations feature hands-free controls (sensor, knee, or foot-operated), automatic water and disinfectant dispensers, and sometimes built-in timers to enforce compliance with infection control standards.',
    specifications: [],
    size: [],
    types: []
  
  }, 
  {
    id: 38,
    category: 'modular-operation-theatre',
    name: 'Extension Arm for Endoscopy',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Ceiling‑ or wall‑mounted articulating arm for endoscopy equipment",
      "Holds cameras, monitors, light sources, and scopes with stable support",
      "Multi‑joint, height‑adjustable design for precise, ergonomic positioning",
      "Frees floor space and reduces cable clutter in procedure rooms",
      "Suitable for laparoscopic, GI, urology, and other minimally invasive cases",
      "Improves surgical workflow and visualization during endoscopic surgery",
      "Reduces staff fatigue by eliminating manual equipment holding",
      "Antimicrobial, smooth surfaces for quick cleaning and infection control",
      "Load‑rated joints with friction or spring balancing for effortless movement",
      "Modular system allows future upgrades or additional device mounts"
  ],
    image: '/images/products/extension-arm-for-endoscopy.jpg',
    details: 'An Extension Arm for Endoscopy is a ceiling‑ or wall‑mounted, multi‑joint support arm that carries endoscopy cameras, light sources, monitors, and scopes in operating theatres, GI suites, and procedure rooms. Its articulated, height‑adjustable design lets staff position imaging devices exactly where they are needed, while keeping the floor clear and the sterile field uncluttered. Manufactured from smooth, antimicrobial‑coated aluminium or stainless steel, the arm is easy to wipe‑clean and withstands frequent disinfection.',
    specifications: [],
    size: [],
    types: []
  
  }, 
  {
    id: 39,
    category: 'modular-operation-theatre',
    name: 'Electrical DB',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features :[
      "Distributes electricity safely to hospital departments and critical equipment",
      "Contains circuit breakers and fuses to prevent overloads and short circuits",
      "Ensures power continuity for ICUs, OTs, and diagnostic systems",
      "Supports dual feeds for normal and emergency backup power",
      "Integrates with UPS and generator systems for fail-safe power delivery",
      "Enhances electrical safety and reduces the risk of electrical fires",
      "Clearly labeled circuits for easy identification and maintenance",
      "Built to meet hospital-grade reliability and redundancy standards",
      "Modular design allows future expansion and upgrades",
      "Supports safe power segregation in high-dependency zones"
  ],
    image: '/images/products/electrical-db.jpg',
    details: 'An Electrical Distribution Board (DB) is a centralized panel responsible for distributing electrical power from the hospital’s main supply to individual circuits across the facility. It houses circuit breakers, fuses, and protective switches to manage and safeguard the flow of electricity. Designed for critical environments like ICUs, Operation Theatres, labs, and imaging suites, hospital-grade DBs often include dual power inputs—linking to both the main supply and emergency backup systems like UPS and generators—to guarantee uninterrupted power in life-saving zones.',
    specifications: [],
    size: [],
    types: []
  
  },
  {
    id: 40,
    category: 'modular-operation-theatre',
    name: 'View Window',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Enables patient and procedure observation without entering sterile zones",
      "Installed in OTs, ICUs, isolation rooms, labs, and neonatal units",
      "Made from toughened, laminated, or double-glazed safety glass",
      "Supports privacy with integrated blinds or switchable smart glass",
      "Maintains cleanroom integrity by preventing airflow between rooms",
      "Allows communication and coordination between staff in adjacent rooms",
      "Reduces unnecessary foot traffic into high-risk or sterile areas",
      "Improves patient safety through non-intrusive visual access",
      "Easy to disinfect and compliant with healthcare hygiene standards",
      "Customizable sizes and configurations for various clinical applications"
  ],
    image: '/images/products/view-window.jpg',
    details: 'A View Window is a transparent, fixed-glass panel installed in hospital walls or doors to allow observation between rooms without physical entry. Commonly used in Operation Theatres (OTs), ICUs, isolation wards, and cleanrooms, these windows enable visual monitoring and communication while maintaining sterile barriers and air pressure integrity. Typically made from toughened, laminated, or double-glazed glass, they may include integrated blinds or smart glass for adjustable privacy—making them essential for both infection control and patient supervision.',
    specifications: [],
    size: [],
    types: []
  
  },   
  {
    id: 41,
    category: 'modular-operation-theatre',
    name: 'Storage Units',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Stores sterile instruments, medicines, PPE, and medical equipment",
      "Used in OTs, ICUs, pharmacies, labs, wards, and isolation rooms",
      "Constructed from stainless steel, powder-coated metal, or antimicrobial laminates",
      "Available in open, closed, fixed, or mobile configurations",
      "Modular design allows customization based on department needs",
      "Easy-to-clean surfaces to support infection prevention protocols",
      "Improves organization and accessibility of medical supplies",
      "Reduces contamination risk by allowing segregated storage",
      "Maximizes space usage in compact and high-traffic areas",
      "Durable and compliant with healthcare storage and safety standards"
  ],
    image: '/images/products/storage-units.jpg',
    details: 'Storage Units in hospitals are purpose-built cabinets, racks, and shelving systems used to safely store and organize medical supplies, equipment, medications, instruments, and PPE. Constructed from stainless steel, powder-coated metal, or antimicrobial laminates, they are designed to withstand rigorous cleaning and meet strict infection control standards. Found across Operation Theatres (OTs), ICUs, pharmacies, labs, and utility rooms, these units may be fixed or mobile, open or enclosed, and often modular for flexibility in configuration and space optimization.',
    specifications: [],
    size: [],
    types: []
  
  },
  {
    id: 42,
    category: 'modular-operation-theatre',
    name: 'OT Light',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Provides bright, focused, shadow-free lighting for surgical procedures",
      "Used in major and minor surgeries, including open, laparoscopic, and endoscopic operations",
      "Available in ceiling-mounted, mobile, and pendant-based configurations",
      "LED technology ensures high color accuracy (CRI), low heat, and long lifespan",
      "Adjustable light intensity and focus to suit different surgical phases",
      "Sterile handle allows positioning without breaking aseptic technique",
      "Optional camera integration for documentation and teaching",
      "Color temperature control enhances visibility of tissues and vessels",
      "Energy-efficient design reduces operating room power consumption",
      "Reduces surgeon fatigue by improving visual comfort and clarity"
  ],
    image: '/images/products/ot-light.jpg',
    details: 'An OT Light, also known as an Operating Light or Surgical Light, is a high-intensity lighting system designed to provide bright, shadow-free, and focused illumination of the surgical field. Commonly ceiling-mounted or mobile, these lights are essential in Operation Theatres (OTs) across all surgical specialties. Modern OT lights utilize LED technology for better color rendering, energy efficiency, and low heat emission. Advanced models include camera integration, color temperature control, and sterile handle operation to enhance surgical precision and patient safety.',
    specifications: [],
    size: [],
    types: []
  
  }, 
  {
    id: 43,
    category: 'modular-operation-theatre',
    name: 'Medical Isolation Panel',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Provides electrically isolated power circuits for critical care equipment",
      "Reduces risk of electric shock in high-risk zones like OTs and ICUs",
      "Includes isolating transformers, LIMs, alarms, and fault indicators",
      "Monitors insulation resistance and detects leakage currents in real-time",
      "Allows early fault detection without interrupting medical equipment operation",
      "Ensures uninterrupted power during electrical disturbances or faults",
      "Protects sensitive surgical and diagnostic devices from surges or electrical noise",
      "Complies with IEC 60364-7-710 and other international electrical safety standards",
      "Supports patient and staff safety in electrically sensitive environments",
      "Used in wet areas or where high electrical reliability is mandatory"
  ],
    image: '/images/products/medical-isolation-panel.jpg',
    details: 'A Medical Isolation Panel is a specialized electrical safety system designed for use in Operation Theatres (OTs), ICUs, and other high-dependency hospital zones. It isolates electrical circuits from the main power supply using isolating transformers, thereby minimizing the risk of electrical shock and leakage currents. Equipped with Line Isolation Monitors (LIMs), visual indicators, and alarm systems, it continuously monitors insulation resistance and grounding faults—without interrupting the power supply—ensuring uninterrupted, safe operation of life-critical equipment.',
    specifications: [],
    size: [],
    types: []
  
  },
  {
    id: 44,
    category: 'modular-operation-theatre',
    name: 'OT integration',
    description: 'Integrated control panel for surgeons with electrical distribution features.',
    features : [
      "Centralized control of surgical equipment, lights, imaging, and video systems",
      "Real-time access to patient records, imaging data, and lab reports during surgery",
      "Supports telemedicine, live broadcasting, and remote consultations",
      "Enables video recording and documentation of procedures for teaching or legal reference",
      "Integrated control of environmental settings like HVAC, lighting, and gas systems",
      "Improves workflow by reducing manual switching between devices",
      "Enhances coordination among surgical team through shared visual interfaces",
      "Reduces physical clutter by eliminating redundant monitors and controls",
      "Supports minimally invasive and image-guided hybrid surgeries",
      "Boosts operational efficiency, safety, and patient care in advanced OTs"
  ],
    image: '/images/products/ot-integration.jpg',
    details: 'OT Integration refers to the centralized digital control and coordination of all surgical equipment, data systems, imaging, and environmental settings within an Operation Theatre (OT) through a unified interface. It connects surgical lights, cameras, displays, medical gases, patient data, and HVAC/lighting controls into a single, streamlined system. This integration enhances workflow, supports minimally invasive and hybrid surgeries, enables live streaming and telemedicine, and ensures real-time access to clinical data—ultimately improving surgical precision, safety, and outcomes.',
    specifications: [],
    size: [],
    types: []
  
  }, 
  {
    id: 45,
    category: 'penumatic-tube-system',
    name: 'Writing White Board',
    description: 'System for safe removal of waste anaesthetic gases.',
    features: [
      'Efficient gas removal',
      'Safety compliant',
      'Low maintenance',
    ],
  },
  {
    id: 46,
    category: 'nurse-call-system',
    name: 'Anaesthesia Gas Scavenging System',
    description: 'System for safe removal of waste anaesthetic gases.',
    features: [
      'Efficient gas removal',
      'Safety compliant',
      'Low maintenance',
    ],
  }
];

const ProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [product, setProduct] = useState(null);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  useEffect(() => {
    const foundProduct = products.find(p => p.id === parseInt(id));
    if (foundProduct) {
      setProduct(foundProduct);
    } else {
      navigate('/products'); // Redirect to products page if product not found
    }
  }, [id, navigate]);

  if (!product) {
    return <div className="flex justify-center items-center h-screen text-gray-700">Loading product details...</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4 max-w-8xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-lg shadow-xl p-8 md:p-12"
        >
          <button 
            onClick={() => {
              if (location.state && location.state.selectedCategory) {
                navigate('/products', { state: { selectedCategory: location.state.selectedCategory } });
              } else {
                navigate('/products');
              }
            }}
            className="text-[#2C2C90] hover:text-[#00B300] font-semibold mb-6 flex items-center"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Products
          </button>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div className="relative">
              <img 
                src={product.image} 
                alt={product.name} 
                className="w-full h-auto max-h-100 content-fit rounded-lg"
              />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4 text-[#2C2C90]">{product.name}</h1>
              <p className="text-gray-700 mb-2 text-lg">{product.details}</p>

              {/* Model, Size, Type section - minimal spacing */}
              {(product.specifications?.length > 0 || product.size?.length > 0 || product.types?.length > 0) && (
                <div className="mb-2">
                  {product.specifications?.length > 0 && product.specifications.some(s => s) && (
                    <>
                      <span className="font-extrabold text-[#2C2C90] tracking-tight mr-2">Model:</span>
                      <span className="text-gray-700">{product.specifications?.filter(s => s).join(', ')}</span><br />
                    </>
                  )}
                  {product.size?.length > 0 && product.size.some(s => s) && (
                    <>
                      <span className="font-extrabold text-[#2C2C90] tracking-tight mr-2">Size:</span>
                      <span className="text-gray-700">{product.size?.filter(s => s).join(', ')}</span><br />
                    </>
                  )}
                  {product.types?.length > 0 && product.types.some(t => t) && (
                    <>
                      <span className="font-extrabold text-[#2C2C90] tracking-tight mr-2">Type:</span>
                      <span className="text-gray-700">{product.types?.filter(t => t).join(', ')}</span>
                    </>
                  )}
                </div>
              )}

              <h3 className="text-2xl font-bold mb-4 text-[#2C2C90]">Key Features:</h3>
              <ul className="space-y-3 mb-8">
                {product.features.map((feature, index) => (
                  <li key={index} className="flex items-center text-gray-700">
                    <svg className="w-5 h-5 text-[#00B300] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>

              <button 
                onClick={() => setIsQuoteModalOpen(true)}
                className="bg-[#2C2C90] text-white px-8 py-3 rounded-md hover:bg-[#1A1A5C] transition-colors font-semibold text-lg"
              >
                Request a Quote
              </button>
            </div>
          </div>
        </motion.div>
      </div>
      <RequestQuoteModal
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
        productName={product?.name}
      />
    </div>
  );
};

export default ProductDetails; 